import { IdvBrands, IDVSubmitRequest, } from '@cbbt/itf-identity-verification-journey';
import { IdvStatus, ProofOfIdentity, } from '@cbbt/itf-unverified-individual-customer-domain';
import { DocType } from '../types/identityContextTypes.js';
export const getToken = () => sessionStorage.getItem('token');
export const base64ToBlobHandler = (base64, type) => {
    const array = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
    return new Blob([array], { type });
};
export const getCaseDetailsObject = (getCaseDetails, type) => ({
    caseId: getCaseDetails.caseId,
    processCode: getCaseDetails.processCode,
    caseReferenceNo: getCaseDetails.caseReferenceNo,
    partyDetails: [
        {
            casePartyID: getCaseDetails.partyDetails[0].casePartyID,
            externalSystemId: 0,
            attachmentDetails: [
                {
                    evidenceTypeCode: 'IDVER',
                    overrideEvidenceType: '',
                    documentCode: 'PSD',
                    fileComments: 'desc',
                    fileName: `${type}.jpg`,
                    previewCount: 0,
                    trgSysFileRefNum: '1',
                    contentType: 'image/jpeg',
                },
            ],
        },
    ],
});
export const getBinaryData = (type, document) => {
    if (document) {
        const base64 = document.response.failedImage
            ? document.response.failedImage
            : document.response.imageData;
        const base64String = base64.substring(base64.indexOf(',') + 1);
        const blob = base64ToBlobHandler(base64String, 'image/jpeg');
        const fileName = type === 'document' ? 'document.jpeg' : 'selfie.jpeg';
        const lastModified = Date.now();
        return new File([blob], fileName, { type: 'image/jpeg', lastModified });
    }
    return null;
};
export const getOldDocUploadDetails = (caseDetails) => caseDetails.partyDetails[0].attachmentDetails?.filter((attachment) => attachment.status !== 'DL') || [];
export const getSubmitRequest = (caseDetails, dossierGuid, getDossier, verifyData, individualData, brand, jwt, applicationId, individualId, docType) => {
    const attachmentDetails = getOldDocUploadDetails(caseDetails);
    const request = IDVSubmitRequest.create({
        brand: brand.toLowerCase() === 'bos' ? IdvBrands.BOS : IdvBrands.LTB,
        jwt,
        applicationId,
        individualId,
        proofOfIndentity: docType === DocType.DL_FRONT
            ? ProofOfIdentity.DRIVING_LICENCE
            : ProofOfIdentity.PASSPORT,
        agreeToBiometricCheck: true,
        journeyId: 'ONB_ST_NTB',
        country: individualData.nationalities.nationality || '',
        countryCode: individualData.nationalities.countryCode || '',
        guid: dossierGuid.guid,
        mobileNumber: individualData.personalDetails.mobileNumber || '',
        docUploadCaseId: getDossier.docUploadCaseId,
        status: IdvStatus.OPEN,
        outcome: verifyData.outcome,
        message: verifyData.message ? verifyData.message : verifyData.outcome,
        caseDetails: {
            caseId: caseDetails.caseId,
            processCode: caseDetails.processCode,
            caseReferenceNo: caseDetails.caseReferenceNo,
            caseStatus: caseDetails.caseStatus,
            partyDetails: [
                {
                    casePartyID: caseDetails.partyDetails[0]?.casePartyID,
                    externalSystemId: caseDetails.partyDetails[0]?.externalSystemId,
                    attachmentDetails,
                },
            ],
        },
    });
    return request;
};
export const deleteCaseRequest = (data, deleteObj) => {
    const request = {
        caseId: deleteObj.caseId,
        processCode: deleteObj.processCode,
        caseReferenceNo: deleteObj.caseReferenceNo,
        partyDetails: [
            {
                casePartyID: deleteObj.casePartyID,
                attachmentDetails: [data],
            },
        ],
    };
    return request;
};
//# sourceMappingURL=referenceHelper.js.map